import * as React from "react";
const SvgArrowBack = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 9.238, height: 15.396, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.238 1.559L7.684 0 0 7.7l7.684 7.7 1.554-1.559-6.125-6.139z", fill: "currentColor" }));
export default SvgArrowBack;
